export default {
    data: [
      {
        id: 1,
        ref: "#001",
        articleId: 1,
        desingId: null,
        articlesNumber: 10,
        making: false,
        created_date: "2020-02-10T13:52:38+01:00",
        limit_date: "2020-04-25T13:52:38+01:00",
        finish_date: null,
        pieces: [
            { 
                id: 1,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 2,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 3,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 4,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: false
            },
            { 
                id: 5,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 6,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 7,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 8,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: false
            },
            { 
                id: 9,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 10,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            }
        ],
        article: null,
        desing: null
      },
      {
        id: 2,
        ref: "#002",
        articleId: 2,
        desingId: null,
        articlesNumber: 5,
        making: false,
        created_date: "2020-02-14T13:52:38+01:00",
        limit_date: "2020-04-25T13:52:38+01:00",
        finish_date: null,
        pieces: [
            { 
                id: 1,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 2,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 3,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            },
            { 
                id: 4,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: false
            },
            { 
                id: 5,
                furnace: null,
                quenching: null,
                tempered: null,
                quality: null,
                calidadP: true
            }
        ],
        article: null,
        desing: null
      }
    ]
  };
  